import { configureStore } from '@reduxjs/toolkit'

import { busy } from './busy/reducer.js'
import { dialog } from './dialog/reducer.js'
import { error } from './error/reducer.js'
import { templates } from './templates/reducer.js'
import { folders } from './folders/reducer.js'
import { locale } from './locale/reducer.js'
import { login } from './login/reducer.js'
import { progress } from './progress/reducer.js'
import { save } from './save/reducer.js'
import { selected } from './selected/reducer.js'
import { siteitem } from './siteitem/reducer.js'

const store = configureStore({
  reducer: {
    busy,
    dialog,
    error,
    folders,
    locale: locale(),
    login: login(),
    progress,
    save,
    selected,
    siteitem,
    templates
  }
})

export default store
